import cn from 'classnames';
import { useEffect, useState } from 'react';
import plus from '../../../../assets/media/icons/plus.svg';
import Column from '../../Blocks/Column';
import Row from '../../Blocks/Row';
import AnimateArrow from '../../Buttons/AnimateArrow';
import DropDown from '../../Elements/DropDown';
import Icon from '../../Elements/Icon';
import ScrollBlock from '../../Elements/ScrollBlock';
import Input from '../Base';
import SelectLine from './SelectLine';
import styles from './styles.module.scss';

const keyHandlers = {
  38: 'handleUpKey',
  40: 'handleDownKey',
  32: 'handleSpaceKey',
  13: 'handleEnterKey',
  27: 'handleEscKey',
  74: 'handleDownKey',
  75: 'handleUpKey',
};

export default function SelectInput({
  list = [],
  small = false,
  width,
  select = '',
  fontSize,
  showLine = 8,
  preventState = false,
  placeholder = 'Место',
  label = '',
  disabled = false,
  valueFn = (v) => v,
  children,
  add = false,
  addText = 'Добавить',
  defaultText = 'Без места',
  clickAdd = () => { },
  onSelect = () => {
    console.log('select value');
  },
  onChange = () => { },
  onFocus = () => { },
  onBlur = () => { },
  deletePlace = () => { },
  isOk = false,
  ...props
}) {
  const [value, setValue] = useState(select);
  const [isOpen, changeOpen] = useState(false);

  const [selected, changeSelect] = useState(select);
  const [focus, changeFocus] = useState(-1);
  function openDropDown() {
    onFocus(selected);
    changeOpen(true);
  }
  const closeDropDown = () => {
    changeOpen(false);
    changeFocus(-1);
  };

  const onClickSelect = (item, index) => {
    if (!preventState) {
      changeSelect(item);
    }
    onSelect(item, index);
    closeDropDown();
  };

  useEffect(() => {
    changeSelect(select);
  }, [select]);

  const keyDown = (e) => {
    /* const code = e.keyCode;

    console.log(code);
    if (isOpen) {
      if (Object.keys(keyHandlers).includes(code.toString())) {
        e.preventDefault();
      }

      if (code === 13) {
        if (isOpen) {
          onClickSelect(list[focus], focus);
          closeDropDown();
        }
      }

      if (code === 27) {
        closeDropDown();
      }
      if (code === 40 || code === 38) {
        if (focus === -1) {
          changeFocus(0);
        }
        if (code === 40) {
          changeFocus(focus === list.length - 1 ? 0 : focus + 1);
        } else {
          changeFocus(focus === 0 ? list.length - 1 : focus - 1);
        }
      }
    }*/
  };

  return (
    <Column>
      {label.length > 0 && <div className={styles.input_label}>{label}</div>}

      <div
        className={cn(
          styles.select,
          isOk === true && styles.is_ok,
          isOk === false && styles.is_not_ok,
          small && styles.select_small,
          isOpen && styles.border_black,
          props.styles,
        )}
        style={{ width, fontSize, ...props.style }}
        id="drop-down"
        onKeyDown={keyDown}
        onClick={() => {
          if (isOpen) {
            closeDropDown();
          } else {
            openDropDown();
          }
        }}
      >
        {isOk !== null && (
          <AnimateArrow
            isOpen={disabled ? (_) => _ : isOpen}
            styles={cn(styles.open_icon_arrow, small && styles.arrow_small)}
          />
        )}
        {/* {valueFn(selected) && valueFn(selected).toString().length > 0 ? (
          valueFn(selected)
        ) : (
          <span className={styles.placeholder}>{placeholder}</span>
        )}*/}
        <Input
          value={selected}
          onChange={(v) => {
            onChange(v);
            changeOpen(true);
            setValue(v);

            console.log(v);
          }}
          onBlur={onBlur}
          styles={styles.input_not_focus}
          placeholder={placeholder}
        />
        {/*isOpen && !disabled &&*/} {/* /*add && isOk === false && selected.length > 1*/}
        {isOpen && !disabled && (
          <DropDown
            styles={cn(styles.select_drop_down, small && styles.select_drop_down_small)}
            close={() => closeDropDown()}
          >
            <div>
              <ScrollBlock maxHeight={showLine * 38}>
                {(list || []).map((item, key) => {
                  return (
                    <SelectLine
                      key={key}
                      item={valueFn(item)}
                      disabled={typeof item === 'object' ? item.disabled : false}
                      focus={focus === key}
                      onMouseOver={() => changeFocus(key)}
                      onSelect={() => onClickSelect(item, key)}
                      small={small}
                    />
                  );
                })}

                {isOk === false && selected?.length > 2 && add && (
                  <>
                    <SelectLine
                      focus={focus === list?.length}
                      onMouseOver={() => changeFocus(list?.length)}
                      onSelect={() => {
                        clickAdd(selected);
                        closeDropDown();
                      }}
                      small={small}
                      style={{ background: '#b4ffa082' }}
                    >
                      <Row>
                        <Icon src={plus} height={'12px'} style={{ marginRight: '3px', marginBottom: '3px' }} />{' '}
                        {selected}
                      </Row>
                    </SelectLine>
                  </>
                )}
                {isOk === false && value.length === 0 && (
                  <>
                    <SelectLine
                      focus={focus === list.length}
                      onMouseOver={() => changeFocus(list.length)}
                      onSelect={() => {
                        deletePlace();
                        closeDropDown();
                      }}
                      small={small}
                      style={{ background: 'rgba(255,160,185,0.51)' }}
                    >
                      {defaultText}
                    </SelectLine>
                  </>
                )}
              </ScrollBlock>
            </div>
          </DropDown>
        )}
      </div>
    </Column>
  );
}
